// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml = require("@rescript/std/lib/js/caml.js");
var Belt_Id = require("@rescript/std/lib/js/belt_Id.js");
var Belt_Map = require("@rescript/std/lib/js/belt_Map.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");

function cmp(key1, key2) {
  var key1$1 = key1 + 0 | 0;
  var key2$1 = key2 + 0 | 0;
  return Caml.int_compare(key1$1, key2$1);
}

var Cmp = Belt_Id.MakeComparable({
      cmp: cmp
    });

function getStatus(feature, t) {
  return Belt_Option.getWithDefault(Belt_Map.get(t, feature), /* Off */1);
}

function make(t) {
  if (t === undefined) {
    return Belt_Map.make(Cmp);
  }
  var imagePlaceholder_1 = t.imagePlaceholder ? /* On */0 : /* Off */1;
  var imagePlaceholder = [
    /* ImagePlaceholder */0,
    imagePlaceholder_1
  ];
  var newsletterZoneWithTeaserImage_1 = t.newsletterZoneWithTeaserImage ? /* On */0 : /* Off */1;
  var newsletterZoneWithTeaserImage = [
    /* NewsletterZoneWithTeaserImage */1,
    newsletterZoneWithTeaserImage_1
  ];
  var emacV4_1 = t.emacVersion === "v4" ? /* On */0 : /* Off */1;
  var emacV4 = [
    /* EmacV4 */2,
    emacV4_1
  ];
  var themeSwitch_1 = t.themeSwitch ? /* On */0 : /* Off */1;
  var themeSwitch = [
    /* ThemeSwitch */3,
    themeSwitch_1
  ];
  var settingsManuTargetedComms_1 = t.settingsMenuTargetedComms ? /* On */0 : /* Off */1;
  var settingsManuTargetedComms = [
    /* SettingsMenuTargetedComms */4,
    settingsManuTargetedComms_1
  ];
  var settingsMenuQualityVideo_1 = t.settingsMenuQualityVideo ? /* On */0 : /* Off */1;
  var settingsMenuQualityVideo = [
    /* SettingsMenuQualityVideo */5,
    settingsMenuQualityVideo_1
  ];
  var sliderMetaInfoButtonSeeMore_1 = t.sliderMetaInfoButtonSeeMore ? /* On */0 : /* Off */1;
  var sliderMetaInfoButtonSeeMore = [
    /* SliderMetaInfoButtonSeeMore */6,
    sliderMetaInfoButtonSeeMore_1
  ];
  var userPanel_1 = t.userPanel ? /* On */0 : /* Off */1;
  var userPanel = [
    /* UserPanel */7,
    userPanel_1
  ];
  var fsk_1 = t.fsk ? /* On */0 : /* Off */1;
  var fsk = [
    /* Fsk */8,
    fsk_1
  ];
  var internalAuth_1 = t.internalAuth ? /* On */0 : /* Off */1;
  var internalAuth = [
    /* InternalAuth */9,
    internalAuth_1
  ];
  var newConcertHeader_1 = t.newConcertHeader ? /* On */0 : /* Off */1;
  var newConcertHeader = [
    /* NewConcertHeader */11,
    newConcertHeader_1
  ];
  return Belt_Map.fromArray([
              emacV4,
              imagePlaceholder,
              newsletterZoneWithTeaserImage,
              emacV4,
              themeSwitch,
              settingsManuTargetedComms,
              settingsMenuQualityVideo,
              sliderMetaInfoButtonSeeMore,
              userPanel,
              fsk,
              internalAuth,
              newConcertHeader
            ], Cmp);
}

exports.getStatus = getStatus;
exports.make = make;
/* Cmp Not a pure module */
